import '@updater-components/icon';
import template from './welcome.html';
import { actions, selectors } from '../../state';
import { STATES, ENTITY_NAMES } from '../../constants';
import { features } from './features';
import './welcome.global.css';

class WelcomeController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { connect, getState } = this.updStore;

    this.disconnect = this.updStore.connect(mapStateToThis)(this);

    // Attached to the form, so initializing outside of mapStateToThis
    this.credentials = {
      email: selectors.signUp.userEmail(getState()),
    };
  }

  $onDestroy() {
    this.disconnect();
  }

  onSubmit(credentials) {
    const { dispatch } = this.updStore;
    dispatch(actions.signUp.setCredentials(credentials));
    dispatch(actions.router.stateGo(STATES.GET_STARTED_1));
    dispatch(actions.analytics.track('Set Email and Password'));
  }
}

export const WelcomeComponent = {
  template,
  controller: WelcomeController,
};

function mapStateToThis(state) {
  const siteConfig = selectors.current.siteConfig();
  const itemDefinitionsCodes = siteConfig.itemDefinitionsCodes(state);
  const companyName =
    siteConfig.divisionName(state) || siteConfig.companyName(state);

  return {
    inviteToken: selectors.signUp.inviteToken(state),
    companyName,
    showCompanyMessage: companyName && companyName !== ENTITY_NAMES.UPDATER,
    features: features.filter(
      ({ code }) => itemDefinitionsCodes.indexOf(code) !== -1
    ),
  };
}
